export const OBTENER_LLAVES = 'get_llaves';
export const GET_CONFIG_FORMINF = 'get_config_form_inf';
export const GET_TIPOS_INFORME = 'get_tipos_informe';
export const GET_COMPANIAS = 'get_companias';
export const GET_ESTADOS = 'get_estados';
export const GET_SITUACIONES = 'get_situaciones';
export const GET_CRITERIOS_FECHA = 'get_criterios_fecha';
export const GET_CRITERIOS_PEND = 'get_criterios_pendientes';
export const GET_INFORMES_PREVIOS = 'get_informes_previos';
export const POST_GENERAR_INFORME = 'post_generar_informes';
export const GET_PROVEEDORES = 'get_proveedores';


export const GET_CONFIG_FORM_DESC = 'get_config_form_descarga';
export const GET_TIPOS_DESCARGA = 'get_tipos_descarga';
export const GET_RESPONSABLES = 'get_responsables';
export const GET_CRITERIOS_FECHA_DESC = 'get_criterios_fecha_desc';
export const GET_DESC_PREVIAS = 'get_descargas_previas';
export const POST_GENERAR_DESCARGA = 'post_generar_descarga';